import { PayInFilter } from '../constants';

export type ContentPropsT = {
	handleFilterSubmit: (submittedFilters: PayInFilter) => void;
	onClose: () => void;
};

export const FORM_FIELD_KEYS = {
	MERCHANT_NAME: 'merchantName',
	ORDER_ID: 'orderID'
};

export const MERCHANTS_NAME = {
	Mobikwik: 'mobikwik',
	Cashfree: 'cashfree',
	Juspay: 'juspay',
	Paytm: 'paytm',
	Razorpay: 'razorpay',
	Phonepe: 'phonepe'
};
